import React, { useState } from 'react';
import { Row, Col, Avatar, Typography, Button } from 'components/ds';
import { MobileOutlined, DesktopOutlined, CalendarOutlined, TableOutlined } from '@ant-design/icons';

const { Title, Text, Link } = Typography;

const DeviceViewer = ({ children }:any) => {
    const [, setView] = useState('desktop');

    return (
        <>
            <Row align="middle" justify="space-between" style={{ top:'0px', padding: '16px', width: '100%', zIndex: '10', backgroundColor: '#f0f2f5', background: 'var(--colorBgBase)' }}>
                <Col>
                    <Row align="middle">
                        <Avatar
                            src="https://via.placeholder.com/40"
                            alt="Programa Champions Logo"
                            size={40}
                            style={{ marginRight: '16px' }}
                        />
                        <div>
                            <Title level={4} style={{ margin: 0 }}>Programa Champions (tenant)</Title>
                            <Text type="secondary">Programa de incentivo • 00/00/00 a 00/00/00</Text>
                        </div>
                    </Row>
                </Col>
                <Col>
                    <Row align="middle">
                        <Link href="#" style={{ marginRight: '16px' }}>Visualizar plataforma publicada</Link>
                        <Text type="secondary" style={{ marginRight: '24px' }}>Última publicação: 00/00/00 às 00h</Text>
                        <Button
                            icon={<MobileOutlined />}
                            style={{ marginRight: '8px' }}
                            onClick={() => setView('mobile')}
                        />
                        <Button
                            icon={<DesktopOutlined />}
                            style={{ marginRight: '8px' }}
                            onClick={() => setView('desktop')}
                        />
                        <Button icon={<CalendarOutlined />} style={{ marginRight: '8px' }} />
                        <Button icon={<TableOutlined />} />
                    </Row>
                </Col>
            </Row>
            <div style={{ padding: '0px 40px'}}>
          
                    <Row justify="center">
                        <Col className="mobileViewer" style={{ borderRadius:'10px', margin: '0px auto 0px auto', height:'calc(100vh - 100px)', overflow: 'hidden', border: '1px solid var(--colorBorderBase)' }}>
                            {children}
                        </Col>
                    </Row>
            </div>
        </>
    );
};

export default DeviceViewer;
